import { render, staticRenderFns } from "./DishItems.vue?vue&type=template&id=43849663&scoped=true"
import script from "./DishItems.vue?vue&type=script&lang=js"
export * from "./DishItems.vue?vue&type=script&lang=js"
import style0 from "./DishItems.vue?vue&type=style&index=0&id=43849663&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43849663",
  null
  
)

export default component.exports